import React from "react";
import { DollarSign, Zap, BarChart2, Settings } from "lucide-react";

const UPCOMING_FEATURES = [
  {
    icon: <Zap size={18} />,
    title: "Strategy-Driven Pricing",
    desc:
      "Link charges to pricing strategies for automatic cost calculation based on material, area, and quantity.",
  },
  {
    icon: <Settings size={18} />,
    title: "Material & Input Mapping",
    desc:
      "Map sales selections (e.g. Polyester, Cotton) to production materials like Poly Ink or Cotton Ink for accurate BOM costing.",
  },
  {
    icon: <BarChart2 size={18} />,
    title: "Exact Price Table Lookup",
    desc:
      "Resolve pricing from qty tier × area tier × color count — strict table lookups, no guesswork or multipliers.",
  },
  {
    icon: <DollarSign size={18} />,
    title: "Preview Simulator",
    desc:
      "Test strategies before go-live — enter material, area, qty and colors to validate calculated cost and pricing trace.",
  },
];

const ChargeStrategies = () => {
  return (
    <div className="materials-container">
      {/* Header */}
      <div className="page-header">
        <div>
          <h1 className="page-title">Charge Strategies</h1>
          <p className="page-subtitle">
            Configure pricing rules and charge models for production
          </p>
        </div>
        <span
          className="status-badge inactive"
          style={{ alignSelf: "flex-start", padding: "6px 14px", fontSize: 13 }}
        >
          <span className="status-dot" />
          Coming Soon
        </span>
      </div>

      {/* Coming Soon Card */}
      <div
        className="table-card"
        style={{ padding: "48px 32px", textAlign: "center", marginBottom: 24 }}
      >
        <div
          style={{
            width: 64,
            height: 64,
            background: "#eff6ff",
            borderRadius: "50%",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            marginBottom: 16,
            color: "#2563eb",
          }}
        >
          <DollarSign size={28} />
        </div>
        <h2
          style={{
            fontSize: 20,
            fontWeight: 700,
            color: "#0f172a",
            margin: "0 0 10px",
            justifyContent: "center",
          }}
        >
          Charge Strategies — Coming Soon
        </h2>
        <p
          style={{
            fontSize: 14,
            color: "#64748b",
            maxWidth: 480,
            margin: "0 auto",
          }}
        >
          "Charge Strategies will allow charges to be strategy-driven — defining
          material inputs, area tiers, and exact price table lookups so
          production costs are always precise and traceable."
        </p>
      </div>

      {/* Upcoming Features Grid */}
      <div
        className="stats-grid"
        style={{ gridTemplateColumns: "repeat(2, 1fr)" }}
      >
        {UPCOMING_FEATURES.map((f) => (
          <div className="stat-card" key={f.title}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 10,
                marginBottom: 8,
              }}
            >
              <span style={{ color: "#2563eb" }}>{f.icon}</span>
              <span style={{ fontWeight: 700, fontSize: 14, color: "#0f172a" }}>
                {f.title}
              </span>
            </div>
            <p
              style={{
                fontSize: 13,
                color: "#64748b",
                margin: 0,
                lineHeight: 1.5,
              }}
            >
              {f.desc}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ChargeStrategies;
